import { useEffect, useMemo, useState } from 'react';

export function useScreenMediaQuery(): {
	isLessThan480: boolean;
	isLessThan640: boolean;
	isLessThan768: boolean;
	isLessThan1024: boolean;
	isLessThan1280: boolean;
} {
	const [width, setWidth] = useState(window.innerWidth);
	useEffect(() => {
		const handleWindowResize = (): void => setWidth(window.innerWidth);
		window.addEventListener('resize', handleWindowResize);
		return (): void => window.removeEventListener('resize', handleWindowResize);
	}, [setWidth]);

	//switched from < to <= to align with the media queries we use
	return useMemo(() => ({
		isLessThan480: width <= 480,
		isLessThan640: width <= 640,
		isLessThan768: width <= 768,
		isLessThan1024: width <= 1024,
		isLessThan1280: width <= 1280,
	}), [width]);
}